<!--
/*******************************************************************************
*@ 컴포넌트명   : SelectBox.vue
*@ 컴포넌트설명 : selectbox 공통컴포넌트
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <vuelidate-form :validator="isValidator ? $v.selectedValue : null" :validator-params="errMsgParam" :messages="errMsg">
    <div class="form-select-field">
      <label class="form-label" v-if="label || $t(labelI18n)">
        {{ label || $t(labelI18n) }}
        <required v-if="isValidator && useRequired" />
      </label>
      <div
        class="form-select"
        :class="[{ disabled }, { readonly }, { 'arrow-none': arrowNone }]"
        @click="
          () => {
            (actionSheetOpend = !(disabled || readonly)), $emit('click');
          }
        "
      >
        <span class="option" :class="{ placeholder: selectedIndex == -1 }">
          <span v-if="selectedIndex == -1">{{ $t(defaultText) }}</span>
          <span v-else>{{ i18nUse ? $t(selectedText) : selectedText }}</span>
        </span>
      </div>
      <action-sheet
        :opened.sync="actionSheetOpend"
        :action-header="Boolean(label || $t(labelI18n) || $t(onlyTitle))"
        :action-footer="optionList.length == 0"
        :no-negative-button="false"
        :confirm="'drwot|acno'.includes(template) ? 'MMENU-0045' : 'MCOM-0000003'"
        @confirm="
          () => {
            if ('drwot|acno'.includes(template)) $router.push({ name: 'manageAccountsList' });
          }
        "
        :title="label || $t(labelI18n) || $t(onlyTitle)"
        :class="['action-sheet', cssType ? cssType : '', optionList.length > 0 ? 'action-sheet--list-type' : '']"
      >
        <template #content>
          <template v-if="optionList.length > 0">
            <!-- 옵션있음 -->
            <ul>
              <li v-if="!hiddenDefaultText" @mouseup="optionClick(-1)">{{ i18nUse ? $t(defaultText) : defaultText }}</li>
              <li v-for="(op, i) in optionList" :key="i" @mouseup="optionClick(op)" :class="{ selected: selectedValue == op.value }">
                <!-- 출금계좌 -->
                <drwot-template v-if="template == 'drwot'" :data="op.data" />
                <!-- 이체그룹 -->
                <select-desc-template v-else-if="template == 'desc'" :data="op.data">
                  <template #text v-if="i18nUse">{{ $t(op.text) }}</template>
                  <template #text v-else>{{ op.text }}</template>
                </select-desc-template>
                <!-- 전계좌번호 -->
                <default-template v-else-if="template == 'acno'">
                  <template #text v-if="i18nUse">
                    <template v-if="!_.isNil(op.data) && !_.isNil(op.data.alias)">
                      {{ $t(op.data.alias) }}
                      <br />
                    </template>
                    {{ $t(op.text) }}
                  </template>
                  <template #text v-else>{{ op.text }}</template>
                </default-template>
                <!-- 기타 -->
                <default-template v-else>
                  <template #text v-if="i18nUse">{{ $t(op.text) }}</template>
                  <template #text v-else>{{ op.text }}</template>
                </default-template>
              </li>
            </ul>
          </template>
          <template v-else>
            <!-- 옵션없음 -->
            <template v-if="template != 'default'">
              <slot name="noData" />
            </template>
            <template v-else>
              <strong class="info-question nomargin-top">{{ /*선택 가능한 데이터가 없습니다.*/ $t("MCOM-0000053") }}</strong>
            </template>
          </template>
        </template>
      </action-sheet>
    </div>
  </vuelidate-form>
</template>
<style type="scss" scoped></style>
<script>
import BaseContent from "@/components/BaseContent";
import DefaultTemplate from "@/components/template/Default";
import DrwotTemplate from "@/components/template/Drwot";
import SelectDescTemplate from "@/components/template/SelectDesc";
import { commonProps, valueProps, selectBoxProps, validation } from "@/mixins/basicComponent";
import { required } from "vuelidate/lib/validators";
import { mapFields } from "vuex-map-fields";

export default {
  name: "SelectBox",
  extends: BaseContent,
  mixins: [commonProps, valueProps, selectBoxProps, validation],
  components: { DefaultTemplate, DrwotTemplate, SelectDescTemplate },
  props: {
    errMsg: Object,
  },
  data() {
    return {
      actionSheetOpend: false,
      selectedText: "",
      selectedValue: "",
      selectedIndex: -1,
      selectedData: "",
    };
  },
  computed: {
    ...mapFields("transfer", ["arrowNone"]),
  },
  mounted() {
    if (!this.hiddenDefaultText) this.selectedText = this.defaultText;
    else {
      if (this.optionList.length > 0) {
        if (this.value != "") {
          this.setValue(this.value);
        }
      }
    }
  },
  validations() {
    let customValidations = {};
    if (this.$attrs) {
      for (const key in this.$attrs) {
        if (key == this.$config.VALIDATOR_REQUIRED) {
          customValidations = {
            ...customValidations,
            required,
          };
          this.useRequired = true;
        }
      }
    }

    return {
      selectedValue: customValidations,
    };
  },
  methods: {
    click() {
      this.basicModalOpend = this.selectedValue == "";
      return false;
    },
    /**
     * 옵션 선택
     * @param {Number} option 옵션 index
     */
    optionClick(option) {
      if (typeof option == "number") {
        this.selectedText = !this.hiddenDefaultText ? this.defaultText : "";
        this.selectedValue = "";
        this.selectedIndex = option;
        this.selectedData = "";
      } else {
        for (let [index, op] of this.optionList.entries()) {
          if (option != undefined) {
            if (option == op) {
              this.selectedText = op.text;
              this.selectedValue = op.value;
              this.selectedIndex = index;
              this.selectedData = op.data ? op.data : "";
            }
          }
        }
      }

      if (this.isValidator) {
        this.$v.selectedValue.$touch();
      }
      this.$forceUpdate();
      this.$emit("update:value", this.selectedValue);
      this.$emit("selected", this.selectedText, this.selectedData);
      this.actionSheetOpend = false;
    },
    /**
     * 초기화
     */
    init() {
      if (!this.hiddenDefaultText) {
        this.selectedText = this.defaultText;
        this.selectedValue = "";
        this.selectedData = {};
      } else {
        this.selectedText = this.optionList[0].text;
        this.selectedValue = this.optionList[0].value;
        this.selectedData = this.optionList[0].data ? this.optionList[0].data : "";
      }
      this.selectedIndex = -1;
      this.$emit("update:value", this.selectedValue);
      this.$forceUpdate();
      if (this.isValidator) {
        this.$v.selectedValue.$reset();
      }
    },

    /**
     * set value
     * @param {String} value optionList 안에 있는 value값
     */
    async setValue(value) {
      if (_.isEmpty(this.optionList)) {
        await this.optionList;
      }

      for (let [index, op] of this.optionList.entries()) {
        if (value != undefined) {
          if (value == op.value) {
            this.selectedText = op.text;
            this.selectedValue = op.value;
            this.selectedIndex = index;
            this.selectedData = op.data ? op.data : "";
            break;
          }
        }
      }
      this.$forceUpdate();
      this.$emit("update:value", this.selectedValue);
      if (this.isValidator) {
        this.$v.selectedValue.$touch();
      }
    },
    /**
     * set optionList
     * @param {Array} list [{text: '', value:''}]
     */
    setOptionList(list, isSelect = true) {
      this.$emit("update:optionList", list);
      if (!this.hiddenDefaultText) {
        this.selectedText = this.defaultText;
        this.selectedValue = "";
        this.selectedData = {};
        this.selectedIndex = -1;
      } else {
        if (isSelect && list.length > 0) {
          this.selectedText = list[0].text;
          this.selectedValue = list[0].value;
          this.selectedIndex = 0;
          this.selectedData = list[0].data ? list[0].data : "";
          this.$emit("update:value", this.selectedValue);
        }
      }
      if (this.isValidator) {
        this.$v.selectedValue.$reset();
      }
    },
  },
};
</script>
